export default {
  INITIAL: 'initial',
  CHANGE: 'change',
  UPDATE: 'update',
  ADD: 'add',
  REMOVE: 'remove',
  DELETE: 'delete',
  CLEAR: 'clear',
  DISCONNECT: 'disconnect',
};
